export default __webpack_public_path__ + "static/media/recall_qa.03cb4b63.md";